"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * VideoService API
 * <h1>VideoService contract</h1>  <h2>Important notes</h2> <h3>1. Broadcast entity related notes: </h3>   <b>\'Enabled\'</b> state of a broadcast has two scopes: <b>global</b> (managed by Operator) and <b>Customer-wise</b> (managed by Customer).     <b>Global</b>-scope <b>\'enabled\'</b> state is returned with `[item].enabled` flag.     <b>Customer</b>-wise <b>\'enabled\'</b> state is returned with `[item].customer_settings.enabled` flag.  <br />   <hr>
 *
 * The version of the OpenAPI document: 0.1
 * Contact: vladimir.kuznetsov@almatech.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
function CreateBroadcastFromJSON(json) {
    return CreateBroadcastFromJSONTyped(json, false);
}
exports.CreateBroadcastFromJSON = CreateBroadcastFromJSON;
function CreateBroadcastFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startDate': (new Date(json['start_date'])),
        'sportId': json['sport_id'],
        'title': json['title'],
        'streamType': _1.StreamTypeFromJSON(json['stream_type']),
        'url': json['url'],
    };
}
exports.CreateBroadcastFromJSONTyped = CreateBroadcastFromJSONTyped;
function CreateBroadcastToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_date': (value.startDate.toISOString()),
        'sport_id': value.sportId,
        'title': value.title,
        'stream_type': _1.StreamTypeToJSON(value.streamType),
        'url': value.url,
    };
}
exports.CreateBroadcastToJSON = CreateBroadcastToJSON;
